// Marco de las pantallas POS: columna de filtros (o su riel) y la lista a todo lo ancho.
import type { ReactNode } from 'react';
import { ExplorerPanel } from '@/shared/patterns/MasterDetail';

export function PosShell({
    filtersCollapsed,
    filters,
    children,
}: {
    filtersCollapsed: boolean;
    filters: ReactNode;
    children: ReactNode;
}) {
    return (
        <div
            className="grid min-h-0 flex-1 overflow-hidden bg-background transition-[grid-template-columns]"
            style={{ gridTemplateColumns: `${filtersCollapsed ? '40px' : '200px'} minmax(0,1fr)` }}
        >
            <ExplorerPanel className="border-r border-border">{filters}</ExplorerPanel>
            <ExplorerPanel>{children}</ExplorerPanel>
        </div>
    );
}
